/**
 * @generated SignedSource<<2c3bc8523042ef93f9edffcb13fd93f1>>
 * @relayHash a7f4fd463261c7e36811c794f4aa1d96
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a7f4fd463261c7e36811c794f4aa1d96

import { ConcreteRequest } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type MedicalReportType = "MEDICAL_REPORT" | "OTHER";
export type Ch_uploadMedicalReportFilesInput = {
  files: ReadonlyArray<any>;
  progressNoteId: string;
  reportType: MedicalReportType;
};
export type chMedicalReportUploadMutation$variables = {
  addConnections: ReadonlyArray<string>;
  input: Ch_uploadMedicalReportFilesInput;
};
export type chMedicalReportUploadMutation$data = {
  readonly uploadMedicalReportFiles: {
    readonly uploadMedicalReportFilesOutput: {
      readonly attachments?: ReadonlyArray<{
        readonly attachmentType: DocumentType;
        readonly createdAt: string;
        readonly fileName: string;
        readonly id: string;
        readonly progressNoteId: string;
        readonly reportType: MedicalReportType;
        readonly sessionId: string;
        readonly uploadStatus: FileUploadStatus | null;
        readonly url: string;
      }>;
      readonly error?: {
        readonly fileName: string | null;
        readonly message: string;
      };
      readonly isSuccess?: boolean;
    } | null;
  };
};
export type chMedicalReportUploadMutation = {
  response: chMedicalReportUploadMutation$data;
  variables: chMedicalReportUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addConnections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "MedicalReportAttachment",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attachmentType",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UploadMedicalReportFilesError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ErrorUploadMedicalReportFilesOutput",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chMedicalReportUploadMutation",
    "selections": [
      {
        "alias": "uploadMedicalReportFiles",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_uploadMedicalReportFilesPayload",
        "kind": "LinkedField",
        "name": "ch_uploadMedicalReportFiles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadMedicalReportFilesOutput",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/)
                ],
                "type": "SuccessUploadMedicalReportFilesOutput",
                "abstractKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chMedicalReportUploadMutation",
    "selections": [
      {
        "alias": "uploadMedicalReportFiles",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_uploadMedicalReportFilesPayload",
        "kind": "LinkedField",
        "name": "ch_uploadMedicalReportFiles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadMedicalReportFilesOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendNode",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "attachments",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "addConnections"
                      },
                      {
                        "kind": "Literal",
                        "name": "edgeTypeName",
                        "value": "ch_ProgressNoteEdge"
                      }
                    ]
                  }
                ],
                "type": "SuccessUploadMedicalReportFilesOutput",
                "abstractKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a7f4fd463261c7e36811c794f4aa1d96",
    "metadata": {},
    "name": "chMedicalReportUploadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7434943d54ce0af43d2285ab3d801fb7";

export default node;
